import { render } from "./PaySalary.vue?vue&type=template&id=3a58f924&scoped=true"
import script from "./PaySalary.vue?vue&type=script&lang=js"
export * from "./PaySalary.vue?vue&type=script&lang=js"

import "./PaySalary.vue?vue&type=style&index=0&id=3a58f924&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a58f924"]])

export default __exports__